module.exports = {
      id: "environment-usage",
      viewBox: "0 0 28.781 28.787",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#environment",
      toString: function () {
        return this.url;
      }
    }